module.exports = __webpack_public_path__ + "img/dashboard_alert_image@2x.b83bb6a.png";